import React from 'react';
import { Modal, Button } from 'antd';
import { CloseCircleOutlined } from '@ant-design/icons';
import { formatCurrencyClean } from '../../utils/format';

/**
 * Component for displaying bid rejection modal
 * @param {Object} props
 * @param {boolean} props.visible - Whether the modal is visible
 * @param {number|null} props.lotNumber - Lot number for the rejected bid
 * @param {string} props.errorMessage - Error message to display
 * @param {number|null} props.minimumBid - Minimum bid amount required
 * @param {boolean} props.isAutoBid - Whether this is an auto-bid rejection
 * @param {string} props.lotName - Name/title of the lot
 * @param {Function} props.onClose - Callback function when modal is closed
 */
const BidRejectionModal = ({
    visible,
    lotNumber,
    errorMessage,
    minimumBid,
    isAutoBid,
    lotName,
    onClose
}) => {
    return (
        <Modal
            title={
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <CloseCircleOutlined style={{ color: '#ff4d4f', fontSize: '20px' }} />
                    <span style={{ color: '#cf1322', fontWeight: 700 }}>
                        {isAutoBid ? 'Max-Bid Stopped' : 'Outbid!'}
                        {lotNumber && ` for Lot #${lotNumber}`}
                    </span>
                </div>
            }
            open={visible}
            onCancel={onClose}
            footer={[
                <Button 
                    key="ok" 
                    type="primary" 
                    onClick={onClose}
                    style={{ background: '#ff4d4f', borderColor: '#ff4d4f' }}
                >
                    OK
                </Button>
            ]}
            width={500}
            centered
            closable={true}
            maskClosable={true}
            bodyStyle={{
                padding: '20px',
                background: 'linear-gradient(135deg, #fff1f0 0%, #ffe7e5 100%)'
            }}
        >
            <div style={{ marginBottom: '16px' }}>
                <div style={{ fontSize: '14px', color: '#595959', marginBottom: '12px', lineHeight: '1.6' }}>
                    {errorMessage || 'Someone already bid ahead of you! Please try a higher bid.'}
                </div>
                {minimumBid && (
                    <div style={{ 
                        fontSize: '14px', 
                        color: '#52c41a', 
                        fontWeight: 600,
                        padding: '10px 14px',
                        background: '#f6ffed',
                        borderRadius: '6px',
                        border: '1px solid #b7eb8f',
                        marginTop: '12px'
                    }}>
                        💡 Minimum bid required: {formatCurrencyClean(minimumBid)}
                    </div>
                )}
                {isAutoBid && lotName && (
                    <div style={{ 
                        fontSize: '12px', 
                        marginTop: '12px', 
                        color: '#8c8c8c', 
                        fontStyle: 'italic',
                        padding: '8px',
                        background: '#fafafa',
                        borderRadius: '4px'
                    }}>
                        Max-bid stopped for {lotName}
                    </div>
                )}
            </div>
        </Modal>
    );
};

export default BidRejectionModal;

